module.exports = __webpack_public_path__ + "img/ymc-0.4d168ed0.png";